export default "__VITE_ASSET__BKVTZW33__"